import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { TextField, Alert, Typography, Box, useTheme, useMediaQuery, styled, FormControlLabel } from "__barrel_optimize__?names=Alert,Box,FormControlLabel,TextField,Typography,styled,useMediaQuery,useTheme!=!@mui/material";
import { tokens } from "../theme";
import { useTranslation } from "../../../i18n/client";
import ReusableButton from "./ReusableButton";
import { signIn, useSession } from "next-auth/react";
import { AuthApi } from "../../../../apis/auth";
import { isAxiosError } from "axios";
const StyledFormControlLabel = styled(FormControlLabel)({
    "& .MuiFormControlLabel-label": {
        color: "#515151",
        fontWeight: "500",
        fontSize: "13px"
    }
});
export const ForgotPassForm = (props)=>{
    const [verificationCode, setVerificationCode] = useState("");
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState("info");
    const [emailError, setEmailError] = useState(false);
    const [repeatPasswordError, setRepeatPasswordError] = useState(false);
    const [checked, setChecked] = useState(false);
    const [pressedResend, setPressedResend] = useState(false);
    const [email, setEmail] = useState("");
    const [disabledResetButton, setDisabledResetButton] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const submitInFlightRef = useRef(false);
    const router = useRouter();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const { data: session, status } = useSession();
    const { t } = useTranslation(props.lng, "login");
    const searchParams = useSearchParams();
    const search = searchParams === null || searchParams === void 0 ? void 0 : searchParams.get("callbackUrl");
    const [timeLeft, setTimeLeft] = useState(60);
    useEffect(()=>{
        // Only start the countdown if resendIsPresent is false
        if (!pressedResend || timeLeft === 0) return;
        const timerId = setInterval(()=>{
            setTimeLeft((prevTime)=>prevTime - 1);
        }, 1000);
        // Clear interval when the component unmounts or timeLeft changes
        return ()=>clearInterval(timerId);
    }, [
        pressedResend,
        timeLeft
    ]);
    // Reset countdown when it ends
    useEffect(()=>{
        if (timeLeft === 0) {
            setPressedResend(false); // Enable the resend button or message
            setTimeLeft(60); // Reset the countdown time if needed
        }
    }, [
        timeLeft,
        pressedResend
    ]);
    const handleSignIn = async (email, password)=>{
        const response = await signIn("credentials", {
            email,
            password,
            redirect: false
        });
        if (response === null || response === void 0 ? void 0 : response.error) {
            setMessage(response === null || response === void 0 ? void 0 : response.error);
            setMessageType("error");
        // handle error
        } else {
            // console.log('Next Public Client Url -> ', `${process.env.NEXT_PUBLIC_CLIENT_URL}/${lng}`)
            // console.log('Response URL -> ', `${process.env.NEXT_PUBLIC_CLIENT_URL}/${lng}/application`);
            if (search) {
                // router.refresh();
                // router.prefetch(search);
                // window.history.pushState(null, '', `?${search}`)
                // router.push(`${process.env.NEXT_PUBLIC_CLIENT_URL}/${lng}/application`);
                router.push("".concat(search));
            // window.location.replace(`${process.env.NEXT_PUBLIC_CLIENT_URL}${search}`);
            // router.push(search)
            } else {
                router.push("/application");
            // window.location.replace(`${process.env.NEXT_PUBLIC_CLIENT_URL}/${props.lng}/application`);
            // router.refresh();
            // router.push(`${process.env.NEXT_PUBLIC_CLIENT_URL}/${lng}/application`);
            }
        // router.refresh();
        // router.push(`${window.location.origin}/${lng}/application`);
        // router.push(`${process.env.NEXT_PUBLIC_CLIENT_URL}/${lng}/application`)
        }
    // if (result?.error) {
    //   setMessage(result.error);
    //   setMessageType("error");
    // }
    };
    const handleSubmit = async (event)=>{
        event.preventDefault();
        if (disabledResetButton || submitInFlightRef.current) return;
        submitInFlightRef.current = true;
        setIsSubmitting(true);
        setMessage("");
        try {
            await AuthApi.forgotPassword({
                email: email,
                locale: props.lng
            });
            setMessageType("info");
            setMessage(t("recoveryLinkSent"));
            setDisabledResetButton(true);
        } catch (error) {
            if (isAxiosError(error)) {
                var _error_response, _error_response1, _error_response_data, _error_response2;
                if (((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === 404) {
                    setMessage(t("emailNotFound"));
                    setMessageType("error");
                } else if (((_error_response1 = error.response) === null || _error_response1 === void 0 ? void 0 : _error_response1.status) === 400 && ((_error_response2 = error.response) === null || _error_response2 === void 0 ? void 0 : (_error_response_data = _error_response2.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message) === "Password reset is only available for credentials accounts.") {
                    setMessage(t("passwordResetCredentialsOnly"));
                    setMessageType("error");
                } else {
                    setMessage(t("resetLinkError"));
                    setMessageType("error");
                }
            } else {
                setMessage(t("resetLinkError"));
                setMessageType("error");
            }
        } finally{
            setIsSubmitting(false);
            submitInFlightRef.current = false;
        }
    // handleSignIn(props.email, props.password);
    };
    const handleChangeVerificationCode = (event)=>{
        setVerificationCode(event.target.value);
    };
    const handleResendVerificationCode = async ()=>{
        try {
            // await AuthApi.sendVerificationCode({email: props.email})
            setPressedResend(true);
        } catch (error) {
            setMessage("An error occuried during resend of verification code");
            setMessageType("error");
        }
    };
    const helperText = (resendIsPresend)=>{
        if (resendIsPresend) {
            return /*#__PURE__*/ _jsxs("span", {
                children: [
                    "Send code after ",
                    timeLeft,
                    " seconds."
                ]
            });
        } else {
            return /*#__PURE__*/ _jsxs("span", {
                children: [
                    " This code is valid for 5 minutes.",
                    " ",
                    /*#__PURE__*/ _jsx("span", {
                        onClick: handleResendVerificationCode,
                        style: {
                            cursor: "pointer",
                            textDecoration: "underline"
                        },
                        children: "Resend"
                    })
                ]
            });
        }
    };
    const handleChangeEmail = (event)=>{
        setEmail(event.target.value);
        setMessage("");
        // Check if the email is in the correct format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setEmailError(!emailRegex.test(event.target.value));
    };
    return /*#__PURE__*/ _jsx(Box, {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        sx: {
            backgroundColor: "#F3F5FD"
        },
        children: /*#__PURE__*/ _jsxs(Box, {
            width: "100%",
            maxWidth: isMobile ? 320 : 501,
            p: "30px",
            borderRadius: "20px",
            sx: {
                backgroundColor: "#FFF"
            },
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "h3",
                    component: "h1",
                    style: {
                        textAlign: "center",
                        marginBottom: "20px"
                    },
                    children: t("passwordResetTitle")
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "h6",
                    component: "h1",
                    style: {
                        textAlign: "center",
                        marginBottom: "20px"
                    },
                    children: t("passwordResetSubtitle")
                }),
                /*#__PURE__*/ _jsxs("form", {
                    onSubmit: handleSubmit,
                    style: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ _jsx(TextField, {
                            label: t("email"),
                            type: "email",
                            value: email,
                            onChange: handleChangeEmail,
                            variant: "outlined",
                            margin: "normal",
                            fullWidth: true,
                            required: true,
                            error: emailError,
                            helperText: emailError ? t("invalidEmailFormat") : ""
                        }),
                        /*#__PURE__*/ _jsx(ReusableButton, {
                            name: t("resetPasswordButton"),
                            backgroundColor: colors.button.main,
                            backgroundColorOnHover: colors.button.mainOnHower,
                            type: "submit",
                            color: "#FFF",
                            width: "100%",
                            paddingTop: "20px",
                            disabled: disabledResetButton || emailError || isSubmitting,
                            loading: isSubmitting
                        }),
                        message && /*#__PURE__*/ _jsx(Alert, {
                            severity: messageType,
                            style: {
                                marginTop: "20px"
                            },
                            children: message
                        })
                    ]
                })
            ]
        })
    });
};
